import { memo } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { BulkPaymentTemplate } from 'components/templates/BulkPaymentTemplate';
import { CircularProgress, Backdrop } from '@material-ui/core';
import classes from 'components/templates/override.module.scss';
import { usePayPalClientId } from 'hooks/payment/UsePayPalClientId';

type Props = {};

export const BulkPayment = memo((_props: Props) => {
	const { clientId, loading } = usePayPalClientId();

	if (loading) {
		return (
			<Backdrop className={classes.backdrop} open={loading}>
				<CircularProgress color="inherit" />
			</Backdrop>
		);
	}

	return (
		<PayPalScriptProvider
			options={{
				'client-id': clientId,
				components: 'buttons,hosted-fields',
				intent: 'authorize',
				currency: 'JPY',
				'data-namespace': 'paypal_sdk_bulk_payment',
			}}
		>
			<BulkPaymentTemplate />
		</PayPalScriptProvider>
	);
});
